<template>
  <div class="contain">
      <h3 class="topTitle">{{ $t('Index.PaymentPage.PaymentPage') }}</h3>
      <div class="content f">
          <div class="content_left">
              <div class="content_item paymentMethods f-b">
                  <div style="width: 300px">
                    <h3>{{ $t('Index.PaymentPage.Tips1') }}</h3>
                    <div>
                        <el-radio-group v-model="paymentMethod">
                            <el-radio label="2" :disabled="+pays.totalAmount <= 0">
                                {{ $t('Index.PaymentPage.Paypal') }}
                                <img class="pay-icon" src="../../assets/img/icon/paypal.png" alt="">
                            </el-radio>
                            <!-- <el-radio label="1" :disabled="+grandTotal <= 0">
                                {{$t('confirmOrder.creditCard')}}
                                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
                            </el-radio> -->
                            <!-- <el-radio v-if="$store.state.common.userGroup === 100" label="4" :disabled="+pays.totalAmount <= 0">
                                {{ $t('Index.PaymentPage.Creditcard') }}
                                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
                            </el-radio>
                            <el-radio v-else label="9" :disabled="+pays.totalAmount <= 0">
                                {{ $t('Index.PaymentPage.Creditcard') }}
                                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
                            </el-radio> -->
                            <!-- 2025.06.09 信用卡逻辑调整 全部用空中云汇的（陈琼瑜） -->
                            <el-radio label="4" :disabled="+pays.totalAmount <= 0">
                                {{ $t('Index.PaymentPage.Creditcard') }}
                                <img class="pay-icon" src="../../assets/img/icon/creditcard1.png" alt="">
                            </el-radio>
                            <el-radio label="0" :disabled="+balance < pays.totalAmount"> {{$t('confirmOrder.balance')}} ${{balance}}</el-radio>
                            <el-radio label="3" :disabled="+pays.totalAmount <= 0">
                                {{ $t('Index.PaymentPage.Others') }}
                                <img class="pay-icon" src="../../assets/img/icon/zfb_wx.png" alt="">
                            </el-radio>
                            <!-- 2025.11.07 40seas支付 去掉 -->
                            <!-- <el-radio v-if="info40Seas" label="8" :disabled="info40Seas.status !== 'approved' || +pays.totalAmount > info40Seas.availableCredit || +pays.totalAmount < 2000">
                              40Seas
                              <img class="pay-icon" style="height:16px;margin:0 4px;top: 4px;" src="https://img.kakaclo.com/web-img/home/40seas/logo.png?x-oss-process=image/resize,w_20,h_20,m_fill/format,webp" alt="">
                              <span v-if="info40Seas.status === 'approved'">({{ `${$t('Index.PaymentPage.AvailableBalance')}:${info40Seas.availableCredit}` }})
                                <el-tooltip v-if="+pays.totalAmount < 2000" effect="dark" :content="$t('Index.PaymentPage.Tips40seas1')" placement="top-start">
                                  <i class="iconfont icon-help pointer pay-icon" style="color:#99c41c;top:2px"></i>
                                </el-tooltip>
                              </span>
                              <span v-else-if="['pending', 'manual review'].includes(info40Seas.status) " style="color:#C0C4CC">({{ $t('Index.PaymentPage.UnderReview') }})</span>
                              <span v-else-if="info40Seas.status === 'declined'" style="color:#C0C4CC">({{ $t('Index.PaymentPage.AuditRejected') }})</span>
                              <span v-else style="color:#518EFF;text-decoration:underline;padding-left:6px;cursor: pointer;" @click="payment40SeasBuyerCreditline(true)"> {{ $t('Index.PaymentPage.ApplyNow') }}</span>
                            </el-radio> -->
                        </el-radio-group>
                    </div>
                    <div>
                      <el-button class="proceed_to_checkout" type="primary" @click="putProductAttachments">{{ paymentMethod == 8 ? $t('Index.PaymentPage.PayLater') : $t('Index.PaymentPage.PayNow') }}</el-button>
                    </div>
                  </div>
                  <div class="image f-c-c">
                    <img src="../../assets/img/Rectangle770.png" style="width: 290px;height: 151px">
                  </div>
              </div>
              <div v-for="(item, i) in orderInfo.logistics" :key="item.countryCode" class="content_item deliveryMethod" v-loading="deleveryLoading">
                  <div class="f-b" style="margin-bottom: 10px">
                    <h2 style="font-size:20px">{{ $t('Index.PaymentPage.DeliveryMethod') }}</h2>
                    <h3 style="font-size:16px">{{ $t('Index.PaymentPage.Warehouses') }}: {{ item.countryName }}</h3>
                  </div>
                  <template v-if="item.channelList.length">
                    <div class="channel_group">
                      <section v-for="item in item.channelList" :key="item.channelCode">
                        <div class="channel_item" :class="{channel_item_active: warehouseChannelList[i].channelCode === item.channelCode}" v-if="warehouseChannelList[i].channelCode === item.channelCode">
                          <el-radio v-model="warehouseChannelList[i].channelCode" :label="item.channelCode" @change="e => channelChange(e, i)">
                          <!-- {{`${item.channelType}(${item.deliveryTime}, $${item.estimatedFreight})`}} -->
                          {{`${item.agingGrade} (${item.deliveryTime}, $${item.estimatedFreight})`}}
                          </el-radio>
                      </div>
                      </section>
                    </div>
                  </template>
                  <!-- <template v-else-if="!channelList.length && !deleveryLoading">
                    <div class="f">
                      <div class="image" style="margin-right:14px">
                        <img src="../../assets/img/Group2151.png" style="height:40px;width:40px">
                      </div>
                      <div style="font-size:16px;line-height:24px">
                        <p style="color:#E3444E">Logistics error.</p>
                        <p>Please connect our support team to continue</p>
                      </div>
                    </div>
                  </template> -->
              </div>
              <div class="content_item orderItems_group">
                  <div class="notes f--c">
                      <span>{{ $t('Index.PaymentPage.Notes') }}:</span>
                      <el-input :placeholder="$t('Index.PaymentPage.Tips5')" v-model="notes"></el-input>
                  </div>

                  <div class="table">
                      <el-table
                        :data="orderItems"
                        tooltip-effect="dark"
                        style="width: 100%">
                        <el-table-column
                          :label="$t('Index.PaymentPage.Description')"
                          width="380">
                          <template slot-scope="scope">
                            <div class="f" style="width:100%">
                              <el-popover
                                placement="right"
                                width="200"
                                trigger="hover">
                                <el-image :src="scope.row.sizeImagePath" style="width:100%;" fit="fill"></el-image>
                                <div slot="reference" class="size-img">
                                  <div v-if="[0,4].includes(scope.row.skuStatus)" class="sold-out f-c-c">Out of Stock</div>
                                  <oss-img :src="scope.row.sizeImagePath" style="width:60px;height:80px;" :width="30" :height="40"></oss-img>
                                </div>
                              </el-popover>
                              <div style="margin-left:8px;">
                                <p style="font-weight:bold">
                                  {{scope.row.productName}}
                                  <template v-if="selectedAttachemtList.length && attachmentSelectedList.filter(t => t !== 'Cards').length">
                                    <el-popover
                                        placement="bottom"
                                        width="370"
                                        trigger="hover">
                                        <div class="partsTable">
                                          <p>{{ $t('Index.PaymentPage.CustomizedService') }}</p>
                                          <template v-for="(item, i) in selectedAttachemtList">
                                            <div v-if="item.type !== 'Cards'" :key="item.type+`_${i}`" class="f productBox">
                                              <div class="imageBox">
                                                <el-image :src="item.imageUrl" style="height: 52px;width: 52px"></el-image>
                                              </div>
                                              <div class="f-b fd-c info">
                                                <p>{{item.name}}</p>
                                                <p>x {{scope.row.productNum}}</p>
                                              </div>
                                            </div>
                                          </template>
                                        </div>
                                        <i class="icon-pinpaitemai-tianchong iconfont myAttachemtIcon" style="color: #99C41C" slot="reference"></i>
                                    </el-popover>
                                  </template>
                                </p>
                                <div v-for="item in JSON.parse(scope.row.options)" :key="JSON.parse(item).name">
                                  <p>
                                    <span style="color:#747A87;margin-right:4px">{{JSON.parse(item).name}}:</span>
                                    <span >{{JSON.parse(item).value}}</span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          prop="productNum"
                          label="Qty"
                          width="200">
                        </el-table-column>
                        <el-table-column
                          :label="$t('Index.PaymentPage.UnitPrice')"
                          align="center">
                          <template slot-scope="scope">
                            <div v-if="scope.row.afterDiscountAmount" class="inDiscount">
                              <p>US${{scope.row.afterDiscountAmount}}</p>
                              <p >US${{scope.row.purchasePrices}}</p>
                            </div>
                            <p style="font-size:16px;text-align:center" v-else>US${{scope.row.purchasePrices}}</p>
                          </template>
                        </el-table-column>
                      </el-table>
                      <el-table
                        v-if="cardsTableList.length && attachmentSelectedList.includes('Cards')"
                        :show-header="false"
                        :data="cardsTableList"
                        style="width: 100%">
                        <el-table-column
                          :label="$t('Index.PaymentPage.Description')"
                          width="380">
                          <template slot-scope="scope">
                            <div class="f" style="width:100%">
                              <el-popover
                                placement="right"
                                width="200"
                                trigger="hover">
                                <el-image :src="scope.row.imageUrl" style="width:100%;" fit="fill"></el-image>
                                <div slot="reference" class="size-img">
                                  <oss-img :src="scope.row.imageUrl" style="width:60px;height:80px;" :width="30" :height="40"></oss-img>
                                  <div class="customized f-c-c">SPECIAL</div>
                                </div>
                              </el-popover>
                              <div style="margin-left:8px;">
                                <p style="font-weight:bold">
                                  {{scope.row.name}}
                                </p>
                              </div>
                            </div>
                          </template>
                        </el-table-column>
                        <el-table-column
                          label="Qty"
                          width="200">1
                        </el-table-column>
                        <el-table-column
                          :label="$t('Index.PaymentPage.UnitPrice')"
                          align="center">0
                        </el-table-column>
                      </el-table>
                      <div class="f-e" style="height:76px;line-height:76px">
                        <span style="font-size:14px;color:#747A87;margin-right:4px;">{{ $t('Index.PaymentPage.Weight') }}:</span>
                        <span style="font-size:16px;font-weight:bold;margin-right:24px">{{ `${weightTotal}g` }}</span>
                        <!-- <span style="font-size:14px;color:#747A87;margin-right:4px">Subtotal:</span> -->
                        <!-- <span style="font-size:16px;font-weight:bold;">US ${{tableSubtotal}}</span> -->
                      </div>
                  </div>
              </div>
          </div>
          <div class="content_right">
              <div class="left_shippingAddress f-b content_item p-r">
                  <div>
                      <div style="font-weight: bold;margin-bottom: 10px" class="f--c text_tip">
                          <i class="el-icon-location-information" style="margin-right:4px"></i>{{ $t('Index.PaymentPage.ShippingAddress') }}
                      </div>
                      <!-- <div style="color:#8B93A3;padding-left: 20px">
                          {{addressList[selectAddressIndex].fullName}} {{addressList[selectAddressIndex].phoneNumber}}
                          <p>{{addressList[selectAddressIndex].streetAddressLine1}}</p>
                          <p v-if="addressList[selectAddressIndex].streetAddressLine2">{{addressList[selectAddressIndex].streetAddressLine2}}</p>
                          {{addressList[selectAddressIndex].city}} {{addressList[selectAddressIndex].province}} {{addressList[selectAddressIndex].countryName}} {{addressList[selectAddressIndex].zipCode}} {{addressList[selectAddressIndex].vatCode}}
                      </div> -->
                      <div style="color: #8893A3; padding-left: 20px">
                        {{address.recipient}} {{address.phone}}
                        <p>{{address.street1}}</p>
                        <p v-if="address.street2">
                          {{address.street2}}
                        </p>
                        {{address.city}} {{address.province}} {{address.country}} {{address.zip}}
                      </div>
                  </div>
                  <div style="position: absolute;bottom:0px;left:0;right:0;width:100%">
                    <img src="../../assets/img/Group1858.png" style="width:100%">
                  </div>
                  <div class="f-b fd-c">
                      <el-popover placement="bottom">
                          <div class="select-another-address pointer" slot="reference" style="display: none">{{ $t('Index.PaymentPage.Choose') }}</div>
                          <vue-scroll :style="{ height: `${addressList.length > 3 ? '400': addressList.length*200}px`}">
                              <div class="add-new-address f-c pointer" @click="$refs.addressdialog.show()">
                                  <i class="iconfont icon-a-add-line1"></i>&nbsp;
                                  <span>{{ $t('confirmOrder.addNewAddress') }}</span>
                              </div>
                              <div v-for="(item, index) in addressList" :key="item.id" class="address-item p-r pointer" :class="[index === selectAddressIndex ? 'address-item-activated' : '']" @click="selectAddressIndex = index">
                                  {{item.fullName}} {{item.phoneNumber}}
                                  <p>{{item.streetAddressLine1}}</p>
                                  <p v-if="item.streetAddressLine2">{{item.streetAddressLine2}}</p>
                                  {{item.city}} {{item.province}} {{item.countryName}} {{item.zipCode}} {{item.vatCode}}
                                  <span class="pointer" @click.stop="editAddress(item)">{{$t('confirmOrder.editTheAddress')}}</span>
                                  <div class="activated-icon">
                                    <i class="iconfont icon-check-line"></i>
                                  </div>
                              </div>
                          </vue-scroll>
                      </el-popover>
                      <div class="select-another-address pointer" style="text-align: right;display: none" @click="editAddress(orderInfo.address)">{{ $t('Index.PaymentPage.Edit') }}</div>
                  </div>
              </div>
              <div class="content_item orderAmount">
                  <h2 style="margin-bottom: 10px" class="title">{{ $t('Index.PaymentPage.OrderAmount') }}</h2>
                  <div class="f-b subtotal_item">
                      <p style="color: #747A87">{{ $t('Index.PaymentPage.Subtotal') }}</p>
                      <p>US ${{pays.skusAmount}}</p>
                  </div>
                  <div class="f-b subtotal_item">
                      <p style="color: #747A87">{{ $t('Index.PaymentPage.ShippingFee') }}</p>
                      <p>US ${{currentChannel.estimatedFreight | priceHandle}}</p>
                  </div>
                  <div class="f-b subtotal_item">
                      <p style="color: #747A87">{{ $t('Index.PaymentPage.Discount') }}</p>
                      <p :class="{haveCut: pays.discountAmount}">-US ${{pays.discountAmount | priceHandle}}</p>
                  </div>

                  <!-- 优惠码金额 -->
                  <!-- <div class="f-b subtotal_item">
                    <p style="color: #747A87">{{ $t('Index.PaymentPage.PromoCode') }}</p>
                    <p :class="{haveCut: pays.couponAmount}">-US ${{ pays.couponAmount | priceHandle }}</p>
                  </div> -->

                  <!-- 优惠码金额 -->
                  <div class="payment promo">
                    <span class="payment-left">
                      <span>Promo code</span>
                      <el-popover placement="bottom" trigger="hover">
                        <p class="used-tips">{{ `Promo Code: ${promoCode.couponCode}` }}</p>
                        <div class="choose-to-use">
                          <i class="el-icon-s-ticket" />
                          <span class="get-info">
                            <strong class="get">{{ getOfferDisplayText }}</strong>
                            <span class="discount">{{ `${promoCode.discountRule === 1 ? `${promoCode.discountPercent && promoCode.discountPercent.toFixed(2)}% off` : `$${promoCode.discountFixed && promoCode.discountFixed.toFixed(2)}`}` }}</span>
                          </span>
                        </div>
                        <i v-show="promoCode.couponCode" slot="reference" class="el-icon-s-ticket" />
                      </el-popover>
                    </span>
                    <span class="payment-right" :style="{ color: '#EB5757' }">- USD${{ pays.couponAmount | priceHandle }}</span>
                  </div>

                  <!-- 优惠券金额 -->
                  <!-- <div class="f-b subtotal_item">
                    <p style="color: #747A87">Coupon</p>
                    <p :class="{haveCut: pays.couponTicketAmount}">-US ${{ pays.couponTicketAmount | priceHandle }}</p>
                  </div> -->

                  <!-- 优惠券金额 -->
                  <div class="payment promo">
                    <span class="payment-left">
                      <span>Coupon</span>
                      <el-popover placement="bottom" trigger="hover">
                        <p class="used-tips">{{ `${coupon.id ? 1 : 0} coupon used` }}</p>
                        <CouponItem :coupon="coupon" isDetails class="coupon-item" />
                        <i v-show="coupon.id" slot="reference" class="el-icon-s-ticket" />
                      </el-popover>
                    </span>
                    <span class="payment-right" :style="{ color: '#EB5757' }">- USD${{ pays.couponTicketAmount | priceHandle }}</span>
                  </div>

                  <el-divider></el-divider>
                  <div class="f-b subtotal_all f--c">
                      <p>{{ $t('Index.PaymentPage.Total') }}：</p>
                      <p>US ${{pays.totalAmount | priceHandle}}</p>
                  </div>
              </div>
              <!-- 是否添加配件 -->
              <div class="productParts bg-white content_item">
                <h3 style="margin-bottom: 20px">{{ $t('Index.PaymentPage.CustomizedService') }}</h3>
                <el-checkbox-group v-model="attachmentSelectedList">
                  <div v-for="item in defaultAttachmentsList" :key="item">
                    <el-checkbox :label="item" :disabled="!attachmentsList.some(e=>e.type === item)"></el-checkbox>
                  </div>
                  <!-- <div><el-checkbox label="Tags" :disabled="!attachmentsList.some(e=>e.type === 'Tags')">{{ $t('Index.PaymentPage.Tags') }}</el-checkbox></div> -->
                  <!-- 目前只有一个吊牌，待后续新增后再去除这两个 -->
                  <!-- <template v-if="attachmentsList.length < 2">
                    <div><el-checkbox :label="$t('Index.PaymentPage.Package')" :disabled="true"></el-checkbox></div>
                    <div><el-checkbox :label="$t('Index.PaymentPage.Bags')" :disabled="true"></el-checkbox></div>
                  </template> -->
                </el-checkbox-group>
              </div>
              <!-- 常见问题 -->
              <div class="common-problem content_item">
                  <h3>{{$t('confirmOrder.commonProblem')}}</h3>
                  <el-collapse accordion>
                  <el-collapse-item :title="$t('Index.PaymentPage.HowToReturn')" name="1">
                      <div>{{ $t('Index.PaymentPage.Tips2') }}</div>
                  </el-collapse-item>
                  <el-collapse-item :title="$t('Index.PaymentPage.Tips6')" name="2">
                      <div>{{ $t('Index.PaymentPage.Tips3') }}</div>
                  </el-collapse-item>
                  <el-collapse-item :title="$t('Index.PaymentPage.Tips7')" name="4">
                      <div>{{ $t('Index.PaymentPage.Tips4') }}</div>
                  </el-collapse-item>
                  </el-collapse>
              </div>
          </div>
      </div>
      <AddressDialog ref="addressdialog" :addForm="addressForm" @submitForm="getAddressList"></AddressDialog>
      <QianHai ref="qianhai" @success="paySuccess" @fail="payFail" @cancel="payCancel"></QianHai>
      <Paypal ref="paypal" @success="paySuccess" @fail="payFail" @cancel="payCancel"></Paypal>
      <Airwallex ref="airwallex" :payCallbackUrl="payCallbackUrl" @success="paySuccess" @fail="payFail" @cancel="payCancel" />
      <Payoneer ref="payoneer" :payCallbackUrl="payoneerCallbackUrl" @cancel="payCancel" />
  </div>
</template>
<script>
import API from '@/api'
// import { checkEmail } from '@/util/validate'
import AddressDialog from '@/views/commodity/components/AddressDialog'
import QianHai from '@/components/QianHai.vue'
import Paypal from '@/components/Paypal.vue'
import Airwallex from '@/components/Airwallex.vue'
import Payoneer from '@/components/Payoneer.vue'
import { dateFormat } from '@/util/date'
import { gtagReport } from '@/util/gtag'

import CouponItem from '@/components/CouponItem.vue'

export default {
  components: {
    AddressDialog,
    QianHai,
    Paypal,
    Airwallex,
    Payoneer,
    CouponItem
  },
  filters: {
    priceHandle(value) {
      if (value) return value.toFixed(2)
      return '0.00'
    }
  },
  data() {
    return {
      paymentMethod: '0',
      grandTotal: 0,
      payLoading: null,
      kkOrderId: undefined,
      channelList: [{}],
      channelActive: undefined,
      warehouseChannelList: [],
      deleveryLoading: false,
      countryName: '',
      orderInfo: {},
      /*
    orderInfo: {
      'address': {
        'country': 'CH',
        'city': '深圳',
        'phone': '137562586632',
        'recipient': '铁头男孩',
        'street1': '街道一',
        'street2': '街道二',
        'province': '湖南省',
        'zip': '邮编',
        'vat': 'ssssaca',
        'ioss': ''
      },
      'orderItems': [
        {
          'sizeImagePath': 'LKNASKONCOASNCLKNAS',
          'productName': 'NC 女士缎面真丝睡衣..',
          'productNum': 2,
          'skuCode': 'AMB00393',
          'options': 'XXL',
          'purchasePrices': 12,
          'afterDiscountAmount': 1,
          'kkProductId': 1
        }
      ],
      'orders': {
        'remark': '我不要这个订单的',
        'channelCode': '',
        isExpress: 0,
        deliveryTime: '',
        estimatedFreight: 8.55
      },
      'pays': {
        'totalAmount': 100,
        'freightAmount': 1000,
        'skusAmount': 10000,
        'paymentMethod': 'paypay',
        'discountAmount': 1,
        'couponAmount': 1
      },
      'warehouse': {
        'warehouseCode': '',
        'channelGrouping': '',
        'warehouseId': ''
      }
    }
    */
      selectAddressIndex: 0,
      addressForm: {
        fullName: undefined,
        phoneNumber: undefined,
        streetAddressLine1: undefined,
        streetAddressLine2: undefined,
        city: undefined,
        province: undefined,
        countryCode: undefined,
        zipCode: undefined,
        vatCode: undefined
      },
      notes: undefined,
      paymentAmount: 0,
      balance: 0,
      attachmentSelectedList: [], // 配件列表
      defaultAttachmentsList: [
        'Tags',
        'Bags',
        'Cards'
      ],
      attachmentsList: [],

      paymentId: '', // 付款成功id 交易单id

      coupon: {}, // 优惠券

      promoCode: {}, // 优惠码

      info40Seas: {}, // 40seas-获取用户信用额度
      cardsTableList: [] // 附件 好评卡数组
    }
  },
  created() {
    this.kkOrderId = this.$route.query.kkOrderId
    this.payment40SeasBuyerCreditline()
    this.renderInfo()
    this.getProductAttachments()
  },
  watch: {
    grandTotal(val) {
      if (+val <= 0) {
        this.paymentMethod = '0'
      }
    },
    selectAddressIndex() {
      this.addressForm = this.addressList[this.selectAddressIndex]
    // this.orderChangeAddress(this.addressForm)
    }
  },
  computed: {
    getOfferDisplayText() {
      switch (this.promoCode.discountCondition) {
        case 0: // 无门槛
          return `Get `
        case 1: // 消费满件数
          return `Spend `
        case 2: // 消费满金额
          return `Get `
        default:
          return '-'
      }
    },

    // balance() {
    //   return this.$store.state.common.balance
    // },
    addressList() {
      return this.$store.state.common.addressList
    },
    orderItems() {
      if (this.orderInfo.orderItems) return this.orderInfo.orderItems
      return []
    },
    pays() {
      if (this.orderInfo.pays) return this.orderInfo.pays
      return {}
    },
    currentChannel() {
      if (this.orderInfo.logistics && this.orderInfo.logistics.length) {
        let estimatedFreight = 0
        this.orderInfo.logistics.forEach(item => {
          estimatedFreight += item.estimatedFreight
        })
        return { estimatedFreight }
      }
      return { estimatedFreight: 0 }
    },
    payCallbackUrl() {
      return `${location.origin}/payment-status?state=success&orderId=${this.orderId}&paymentMethod=${this.paymentMethod}&paymentAmount=${this.paymentAmount}`
    },
    payoneerCallbackUrl() {
      return `${location.origin}/payment-status?orderId=${this.kkOrderId}`
    },
    weightTotal() {
      return this.$route.query.weightTotal
    },
    warehouseName() {
      return this.$route.query.warehouseName
    },
    orders() {
      if (this.orderInfo.orders) return this.orderInfo.orders
      return { isExpress: 1, deliveryTime: '', estimatedFreight: '' }
    },
    address() {
      if (this.orderInfo.address) return this.orderInfo.address
      return {}
    },
    selectedAttachemtList() {
      return this.attachmentsList.filter(e => {
        return this.attachmentSelectedList.includes(e.type)
      })
    }
  },
  methods: {
    // 40seas-获取用户信用额度
    payment40SeasBuyerCreditline(isApply) {
      API.payment40SeasBuyerCreditline().then(res => {
        if (res.code === 10000) {
          this.info40Seas = res.data || {}
          if (isApply && this.info40Seas.status !== 'approved ') {
            this.applyNow()
          }
        }
      })
    },
    // 申请40seas
    applyNow() {
      API.payment40SeasBuyer().then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        window._40Seas.open(res.data.token, {
          onCancel: () => {
            window._40Seas.close()
          }
        })
      })
    },
    // 40seas-唤起40seas支付控件
    payment40SeasCheckout() {
      let self = this
      API.payment40SeasCheckout(this.paymentId).then(res => {
        window._40Seas.open(res.data.token, {
          onConfirm: (payload) => {
            // console.log('User entity was conifrmed', payload)
            window._40Seas.close()
            self.paySuccess()
          },
          onCancel: (payload) => {
            // console.log('User closed the modal at page ' + payload.page)
            window._40Seas.close()
            self.payCancel()
          }
        })
      }).finally(() => {
        this.payLoading.close()
      })
    },

    /**
     * API 获取优惠券和优惠码详情
     *
     * @param {Object} parameter 请求参数
     */
    async getUserCouponTicketDetail(parameter) {
      let { data } = await API.getUserCouponTicketDetail(parameter)
      if (data) {
        this.coupon = data.couponTicket || {} // 优惠券
        this.promoCode = data.couponCode || {} // 优惠码
      }
    },

    clickPay() {
    // google 埋点 付款埋点
      window.gtag('event', 'proceed_to_checkout')
      window.gtag('event', 'pay_now')
      // window.gtag('event', 'proceed_to_checkout', { 'send_to': 'G-4335ZYH2TJ' })
      // window.gtag('event', 'pay_now', { 'send_to': 'G-4335ZYH2TJ' })
      // 抖音数据埋点
      window.ttq && window.ttq.track('InitiateCheckout')
      const params = {
        kkOrderId: this.kkOrderId,
        data: {
          remark: this.notes
        }
      }
      API.orderChangeRemark(params).then(() => {
        this.payLoading = this.$loading.service({
          lock: true,
          text: 'Payment Pending',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)',
          customClass: 'el-loading-spinner-box'
        })
        this.createTransactionOrder(this.pays.totalAmount, this.paymentMethod, [this.kkOrderId])
      })
    },
    createTransactionOrder(amount, paymentMethod, kkOrderIds) {
      API.createTransactionOrder({
        amount,
        paymentMethod: +paymentMethod === 4 ? 3 : paymentMethod,
        currencyCode: 'USD',
        paymentType: 0,
        kkOrderIds
      }).then(result => {
        if (result.code !== 10000) {
          this.payLoading.close()
          this.$message.error(result.message)
          return
        }
        this.paymentAmount = amount
        const addr = this.addressList[this.selectAddressIndex]
        const product = this.orderItems[0]
        this.paymentId = result.data
        switch (+this.paymentMethod) {
          case 0:
            this.balancePayment(result.data)
            break
          case 1:
            this.payLoading.close()
            this.$refs.qianhai.show({
              order_number: result.data, // 订单号
              order_amount: amount, // 交易金额
              billing_lastName: addr.fullName, // 持卡人名
              billing_firstName: addr.fullName, // 持卡人姓
              billing_email: this.$store.state.common.email, // 持卡人邮箱
              billing_country: addr.countryCode, // 持卡人国家
              billing_state: addr.province, // 持卡人州/省
              billing_city: addr.city, // 持卡人城市
              billing_address: addr.streetAddressLine1, // 持卡人地址
              billing_zip: addr.zipCode, // 持卡人邮编
              productName: product.productName, // 产品名称
              productNum: product.productNum, // 数量
              productSku: product.skuCode
            })
            break
          case 2:
            this.payLoading.close()
            this.$refs.paypal.show(result.data)
            break
          case 3:
            this.payLoading.close()
            this.$refs.airwallex.show(result.data, ['wechatpay', 'alipaycn'])
            break
          case 4:
            this.payLoading.close()
            this.$refs.airwallex.show(result.data, ['card'])
            break
          case 9:
            this.payLoading.close()
            this.$refs.payoneer.show(result.data)
            break
          case 8:
            this.payment40SeasCheckout()
            break
        }
      }).catch(() => {
        this.payLoading.close()
      })
    },
    getChannelList() {
      const params = {
        warehouses: [
          // {
          //   termini: this.orderInfo.address.country,
          //   warehouseCode: this.orderInfo.warehouse.warehouseCode,
          //   channelGrouping: this.orderInfo.warehouse.channelGrouping,
          //   warehouseId: this.orderInfo.warehouse.warehouseId,
          //   products: this.orderInfo.orderItems.map(e => {
          //     return {
          //       skuCode: e.skuCode,
          //       quantity: e.productNum,
          //       kkProductId: e.kkProductId
          //     }
          //   })
          // }
        ],
        currency: 'USD'
      }
      this.orderInfo.logistics && this.orderInfo.logistics.forEach(item => {
        params.warehouses.push({
          termini: this.orderInfo.address.country,
          zipCode: this.orderInfo.address.zip,
          warehouseCode: item.warehouseCode,
          products: this.orderInfo.orderItems.filter(p => p.warehouseCode === item.warehouseCode).map(e => {
            return {
              skuCode: e.skuCode,
              quantity: e.productNum,
              kkProductId: e.kkProductId
            }
          }),
          platformCode: this.orderInfo.orders && this.orderInfo.orders.platformCode
        })
      })
      this.deleveryLoading = true
      API.getLogisticsChannel(params).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        this.channelList = res.data
        res.data.forEach(item => {
          let channelList = item.data
          if (item.code === 10000 && channelList.length) {
            channelList.forEach((e, i) => {
              if (i === 0) {
                this.$set(e, 'channelType', 'Fast Shipping')
              } else {
                this.$set(e, 'channelType', 'Standard Shipping')
              }
            })
            this.orderInfo.logistics.forEach(e => {
              if (e.warehouseCode === item.warehouseCode) this.$set(e, 'channelList', channelList)
            })
          }
        })
        // this.channelList = res.data[0].data
        // this.channelList.forEach((e, i) => {
        //   if (i === 0) {
        //     this.$set(e, 'channelType', 'Fast Shipping')
        //   } else {
        //     this.$set(e, 'channelType', 'Standard Shipping')
        //   }
        // })
        // 表格勾选的时候调接口，目的是计算运费，不必设默认值
        // if (isNoSetDefault) return
        // 只有一个则第一个，两个以上默认第二个
        // if (this.channelList.length && this.channelList.length === 1) this.channelActive = this.channelList[0].channelCode
        // if (this.channelList.length && this.channelList.length > 1) this.channelActive = this.channelList[1].channelCode
        // this.channelActive = this.orderInfo.orders.channelCode
      }).finally(() => {
        this.loading = false
        this.deleveryLoading = false
      })
    },
    getAddressList(address) {
      this.$refs.addressdialog._data.dialogVisible = false
      this.$refs.addressdialog._data.loading = false
      // this.$store.dispatch('common/getAddressList')
      this.orderChangeAddress(this.addressForm)
    },
    editAddress(address) {
      this.$set(this, 'addressForm', address)
      this.$refs.addressdialog.show()
    },
    /**
   * 支付成功
   */
    paySuccess: function() {
      // 谷歌电子商务 购买埋点
      gtagReport(this.paymentId)
      // 余额付款成功，刷新余额
      if (+this.paymentMethod === 0) this.$store.dispatch('common/getBalance')
      this.$router.replace({
        path: '/payment-status',
        query: {
          state: 'success',
          orderId: this.kkOrderId,
          paymentTime: dateFormat(),
          paymentMethod: this.paymentMethod,
          paymentAmount: this.paymentAmount
        }
      })
    }.after(() => {
    // window.ttq && window.ttq.track('CompletePayment')
    }),
    /**
   * 支付失败
   */
    payFail(error) {
      this.$message.error(error.message || this.$t('orderDetail.payFail'))
      this.$router.replace({
        path: '/payment-status',
        query: {
          state: 'fail',
          orderId: this.kkOrderId
        }
      })
    },
    /**
   * 余额付款
   */
    balancePayment(paymentId) {
      API.balancePayment(paymentId).then(result => {
        this.paySuccess()
      }).finally(() => {
        this.payLoading.close()
      })
    },
    /**
   * 取消支付
   */
    payCancel() {
      this.$router.push('/order/list')
    },
    orderChangeAddress(addressForm, isPay) {
      return new Promise((resolve, reject) => {
        const { countryCode: country, city, phoneNumber: phone, fullName: recipient, streetAddressLine1: street1, streetAddressLine2: street2, province, zipCode: zip } = addressForm
        const params = {
          data: {
            orderAddresses: {
              country,
              city,
              phone,
              recipient,
              street1,
              street2,
              province,
              zip
            },
            paymentMethod: +this.paymentMethod,
            remark: this.notes
          },
          kkOrderId: this.kkOrderId
        }
        API.orderChangeAddress(params).then(res => {
          this.addressForm = {}
          !isPay && this.renderInfo()
          resolve()
        }).catch(() => {
          reject()
        })
      })
    },
    renderInfo() {
      this.payLoading = this.$loading.service()
      API.orderGetDetailToPay(this.$route.query.kkOrderId).then(res => {
        if (res.code !== 10000) return this.$message.error(res.message)
        res.data.logistics && res.data.logistics.forEach((item, i) => {
          this.$set(item, 'channelList', [])
          if (this.channelList.length) {
            this.channelList.forEach(e => {
              if (e.code === 10000 && e.data && e.data.length && e.warehouseCode === item.warehouseCode) {
                this.$set(item, 'channelList', e.data)
              }
            })
          }
        })
        this.orderInfo = res.data
        const { address } = this.orderInfo
        this.selectAddressIndex = this.addressList.findIndex(e => {
          let checkWay = [address.country === e.countryCode, address.city === e.city, +address.phone === +e.phoneNumber, address.street1 === e.streetAddressLine1]
          return checkWay.every(e => e)
        })
        this.notes = this.orderInfo.orders.remark
        this.warehouseChannelList = this.orderInfo.logistics.map(item => ({ isExpress: item.isExpress, warehouseCode: item.warehouseCode, channelCode: item.channelCode }))
        this.getChannelList()
        this.$store.dispatch('common/getBalance').then(balance => {
          this.balance = balance
          if (this.balance < this.orderInfo.pays.totalAmount) {
            this.paymentMethod = '2'
          }
        })
        // 配件默认勾选状态
        if (this.orderInfo.orderItems[0].userAttachmentSkus) {
          this.attachmentSelectedList = this.orderInfo.orderItems[0].userAttachmentSkus.map(e => e.type)
        } else {
          this.attachmentSelectedList = []
        }

        if (this.orderInfo.pays) {
          this.getUserCouponTicketDetail({ userCouponTicketId: this.orderInfo.pays.couponTicketId, couponCode: this.orderInfo.pays.couponCode })
        }
      }).finally(() => {
        this.payLoading.close()
      })
    },
    channelChange(channelCode, i) {
      let channelList = this.orderInfo.logistics[i].channelList
      this.$set(this.warehouseChannelList[i], 'isExpress', channelList.filter(t => t.channelCode === channelCode)[0].agingGrade === 'Express' ? 1 : 0)
      const params = {
        kkOrderId: this.kkOrderId,
        data: {
          // channelCode: this.channelActive
          warehouseChannelList: this.warehouseChannelList.map(item => ({ ...item }))
        }
      }
      API.orderChangeChannel(params).then(res => {
        this.renderInfo()
      })
    },
    // 用户配件列表
    getProductAttachments() {
      // API.getProductAttachments(this.kkOrderId).then(res => {
      API.getNewProductAttachments().then(res => {
        this.attachmentsList = res.data
        this.cardsTableList = res.data.filter(item => item.type === 'Cards')
      })
    },
    putProductAttachments() {
      // 判断配件勾选状态与最初状态是否有更改，区分出新增的与删除的
      // let initialAttachments = []// 初始状态
      // if (this.orderInfo.orderItems[0].userAttachmentSkus) {
      //   initialAttachments = this.orderInfo.orderItems[0].userAttachmentSkus.map(e => {
      //     return {
      //       kkItemId: e.kkItemId,
      //       kkOrderId: e.kkOrderId,
      //       skuCode: e.skuCode,
      //       type: e.type,
      //       id: e.id
      //     }
      //   })
      // }
      // // 新增的
      // let attachmentItemsAdd = this.attachmentSelectedList.map(e => {
      //   return this.attachmentsList.find(ee => ee.type === e)
      // }).map(e => e.skuCode).filter(skuCode => !initialAttachments.some(ee => ee.skuCode === skuCode))
      // // 删除的
      // let attachmentItemsDelete = initialAttachments.filter(e => this.attachmentSelectedList.every(type => type !== e.type)).map(e => e.type)
      // if (!attachmentItemsAdd.length && !attachmentItemsDelete.length) {
      //   this.clickPay()
      //   return
      // }
      // const deleteArr = []
      // this.orderInfo.orderItems.forEach(e => {
      //   if (!e.userAttachmentSkus) return
      //   e.userAttachmentSkus.forEach(ee => {
      //     if (attachmentItemsDelete.includes(ee.type)) deleteArr.push({ id: ee.id })
      //   })
      // })
      // const params = {
      //   addOrderAttachments: [],
      //   deleteOrderAttachments: [
      //     {
      //       kkOrderId: this.kkOrderId,
      //       attachmentItems: deleteArr
      //     }
      //   ]
      // }
      // if (attachmentItemsAdd.length) {
      //   const attachmentItems = this.orderInfo.orderItems.map(e => {
      //     return {
      //       kkItemId: e.kkItemId,
      //       skuCodes: attachmentItemsAdd
      //     }
      //   }).filter(e => e.skuCodes.length)
      //   params.addOrderAttachments = [
      //     { kkOrderId: this.kkOrderId, attachmentItems }
      //   ]
      // }
      if (!this.attachmentsList.length) {
        this.clickPay()
        return
      }
      let list = []
      this.attachmentsList.forEach(item => {
        if (this.attachmentSelectedList.includes(item.type)) {
          if (item.type === 'Cards') {
            list.push({
              kkOrderId: this.kkOrderId,
              // kkItemId: this.orderInfo.orderItems[0].kkItemId,
              skuCode: item.skuCode,
              name: item.name,
              imageUrl: item.imageUrl,
              type: item.type
            })
          } else {
            this.orderInfo.orderItems.forEach(t => {
              list.push({
                kkOrderId: this.kkOrderId,
                kkItemId: t.kkItemId,
                skuCode: item.skuCode,
                name: item.name,
                imageUrl: item.imageUrl,
                type: item.type
              })
            })
          }
        }
      })
      API.putProductAttachments({
        kkOrderIds: [this.kkOrderId],
        list
      }).then(res => {
        this.clickPay()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.payment {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 16px;
  .payment-left {
    color: #7d838f;
  }
  .payment-right {
    font-size: 15px;
  }
}

.used-tips {
  color: #8B93A3;
  margin-bottom: 5px;
}

.promo {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.choose-to-use {
  display: flex;
  width: 317px;
  height: 32px;
  margin: 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid #e3444e;
  background: rgba(227, 68, 78, 0.03);
  .icon-youhuiquan {
    color: #E3444E;
    font-size: 20px;
  }
  .get-info {
    margin-left: 5px;
    .get {
      color: #10141D;
    }
    .discount {
      color: #E3444E;
    }
  }
}

.el-icon-s-ticket {
  color: #E3444E;
  margin-left: 5px;
  cursor: pointer;
}

.contain{
  max-width: 1400px;
  margin: 0 auto;
  min-width: 1000px;
  padding: 0 15px 40px;
  .topTitle {
      padding: 32px 0;
  }
  .content{
      .content_left{
          flex: 1;
          margin-right:36px;
          .paymentMethods{
              h3{
                  margin-bottom: 36px;
              }
              /deep/.el-radio {
                  display: block;
                  margin-bottom: 15px;
              }
              /deep/.el-button {
                  width: 300px;
                  height: 50px;
                  margin-top: 15px;
              }
              .pay-icon{
                  height: 18px;
                  position: relative;
                  top: 4px;
              }
              .image {
                flex: 1;
              }
          }
          .deliveryMethod{
            .channel_group{
              .channel_item{
                padding: 12px 16px;
                width: 490px;
                border: 1px solid #CDD4DD;
                margin-bottom: 10px;
              }
              .channel_item_active{
                border-color: #99C41C;
              }
            }
          }
          .orderItems_group {
              .notes{
                  padding-bottom: 10px;
                  border-bottom: 1px solid #cdd4dd;
                  margin-bottom: 10px;
                  /deep/.el-input__inner{
                      border: none;
                  }
              }
              .table {
                .size-img{
                  position: relative;
                  .sold-out{
                    background: rgba(0, 0, 0, 0.37);
                    position: absolute;
                    width:100%;
                    height: 100%;
                    color: #fff;
                  }
                  .customized{
                    position: absolute;
                    width: 100%;
                    height: 20px;
                    background: #99C41C;
                    bottom: 0;
                    font-size: 10px;
                    color: #fff;
                  }
                }
              }
          }
          .inDiscount {
            >p:nth-of-type(1) {
              font-size: 16px;
              line-height: 24px;
              color: #10141D;
            }
            >p:nth-of-type(2) {
              font-size: 12px;
              color: #747A87;
              text-decoration: line-through;
            }
          }
      }
      .content_right{
          width: 392px;
          .left_shippingAddress {
              .text_tip{
                  font-weight: bold;
                  font-size: 16px;
              }
              .select-another-address {
                font-size: 14px;
                color: #99c41c;
              }
          }
          .orderAmount{
            .subtotal_item{
              margin-bottom: 14px;
              >p:nth-of-type(1) {
                color: #747A87;
                font-size: 14px;
              }
              >p:nth-of-type(2) {
                font-size: 16px;
              }
            }
            .subtotal_all {
              margin-bottom: 14px;
              >p:nth-of-type(1) {
                font-size: 18px;
              }
              >p:nth-of-type(2) {
                font-size: 24px;
              }
            }
            .checkoutBtn {
              margin-bottom: 14px;
              >button{
                width: 100%;
              }
            }
            .numTip{
              text-align: center;
              font-size: 14px;
              span{
                color: #99C41C;
              }
            }
            .paymentOptions {
              p{
                text-align: center;
                color: #8B93A3;
                font-size: 14px;
                margin-bottom: 8px;
              }
              .icon_group {
                img{
                  height: 14px;
                }
              }
            }
            .haveCut {
              color: #E3444E;
            }
          }
          .common-problem{
              padding: 15px 25px;
              h3 {
                  font-weight: 500;
                  font-size: 18px;
                  line-height: 27px;
                  color: #000000;
                  padding-bottom: 25px;
              }
              p {
                  font-weight: 500;
                  font-size: 12px;
                  line-height: 18px;
                  text-decoration-line: underline;
                  padding-bottom: 15px;
              }
          }
          .productParts {
            /deep/.el-checkbox-group{
              >div{
                margin-bottom: 14px;
              }
            }
          }
      }
  }
  .content_item{
      background-color: #FFFFFF;
      padding: 16px 26px;
      border-radius: 3px;
      margin-bottom: 10px;
  }
}
.current-address {
font-size: 14px;
color: #8b93a3;
}
.add-new-address {
font-size: 14px;
color: #99c41c;
line-height: 30px;
padding-bottom: 14px;
}
.address-item {
width: 377px;
border: 0.5px solid #cdd4dd;
border-radius: 6px;
padding: 15px 15px 26px 15px;
margin-bottom: 17px;
overflow: hidden;
span {
  position: absolute;
  right: 10px;
  bottom: 4px;
  color: #99c41c;
}
}
.address-item-activated {
border: 0.5px solid #99c41c;
.activated-icon {
  display: block;
  position: absolute;
  right: -35px;
  top: -35px;
  width: 60px;
  height: 60px;
  border-radius: 100px;
  background: #99c41c;
  color: white;
  i {
    position: absolute;
    bottom: 3px;
    left: 8px;
  }
}
}
.activated-icon {
display: none;
}
</style>

<style lang="scss">
.partsTable {
font-family: 'Poppins';
font-size: 14px;
>p{
  margin-bottom: 14px;
  font-weight: bold;
}
.productBox {
  margin-bottom: 12px;
  .imageBox{
    margin-right: 12px;
  }
  .info{

  }
}
}
.myAttachemtIcon:hover{
  background-color: #F9FCF2;
}
</style>
